<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Vehicle Selection</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<form (ngSubmit)="selectVehicle()" [formGroup]="vehicleSelectionForm">
  <div class="vehicle-selection-container" mat-dialog-content>
    <div class="grid! grid-cols-12 gap-x-20">
      <mat-form-field class="col-span-5">
        <mat-label>Make</mat-label>
        <mat-select (selectionChange)="selectMake()" formControlName="make">
          @for (make of makes(); track make.id) {
            <mat-option [value]="make.id">
              {{ make.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-span-5">
        <mat-label>Model</mat-label>
        <mat-select (selectionChange)="getVariants(); getModelYears()" formControlName="model">
          @for (model of models(); track model.id) {
            <mat-option [value]="model.id">
              {{ model.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="col-span-2">
        <mat-label>Year</mat-label>
        <mat-select (selectionChange)="getVariants(); getYearModels()" formControlName="year">
          @for (year of years(); track year) {
            <mat-option [value]="year">{{ year }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Type to Filter</mat-label>
      <input (keyup)="applyFilter()" formControlName="filter" matInput />
    </mat-form-field>
    <div>
      <mat-checkbox #bankingCheckbox formControlName="unlistedGlassVehicle" [checked]="unlistedGlassVehicle.value">
        The vehicle is not listed
      </mat-checkbox>
    </div>
  </div>

  @if (variants().length > 0) {
    <div class="series">
      <table [dataSource]="variantDataSource" mat-table>
        <ng-container matColumnDef="checkBox">
          <th class="body-2" *matHeaderCellDef mat-header-cell></th>
          <td class="body-1" *matCellDef="let element" [class.selected]="element.nvic === selectedVehicle()" mat-cell>
            <mat-icon>check</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th class="body-2" *matHeaderCellDef mat-header-cell>Series</th>
          <td class="body-1" *matCellDef="let element" mat-cell [class.selected]="element.nvic === selectedVehicle()">
            {{ element.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="bodyType">
          <th class="body-2" *matHeaderCellDef mat-header-cell>Body Type</th>
          <td class="body-1" *matCellDef="let element" mat-cell [class.selected]="element.nvic === selectedVehicle()">
            {{ element.bodyType }}
          </td>
        </ng-container>
        <ng-container matColumnDef="doors">
          <th class="body-2" *matHeaderCellDef mat-header-cell>Doors</th>
          <td class="body-1" *matCellDef="let element" mat-cell [class.selected]="element.nvic === selectedVehicle()">
            {{ element.doors }}
          </td>
        </ng-container>
        <ng-container matColumnDef="transmission">
          <th class="body-2" *matHeaderCellDef mat-header-cell>Transmission</th>
          <td class="body-1" *matCellDef="let element" mat-cell [class.selected]="element.nvic === selectedVehicle()">
            {{ element.transmission }}
          </td>
        </ng-container>
        <ng-container matColumnDef="month">
          <th class="body-2" *matHeaderCellDef mat-header-cell>Month</th>
          <td class="body-1" *matCellDef="let element" mat-cell [class.selected]="element.nvic === selectedVehicle()">
            {{ formatMonth(element.month) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="engine">
          <th class="body-2" *matHeaderCellDef mat-header-cell>Engine</th>
          <td class="body-1" *matCellDef="let element" mat-cell [class.selected]="element.nvic === selectedVehicle()">
            {{ element.engine }}
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr
          id="variant-{{ row.nvic }}"
          (click)="selectedVehicle.set(row.nvic); unlistedGlassVehicle.setValue(false)"
          *matRowDef="let row; columns: displayedColumns"
          mat-row></tr>
      </table>
    </div>
  }
  <div class="guide-last-updated body-2">
    <mat-icon>error_outline</mat-icon>
    <div>Glass Guide last update: {{ lastUpdateDate() }}</div>
  </div>

  <mat-divider class="mx-20!" />

  <mat-dialog-actions>
    <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
    <button
      matButton="elevated"
      class="charcoal-button"
      type="submit"
      [disabled]="(!unlistedGlassVehicle.value && !selectedVehicle()) || pending()">
      SELECT
    </button>
  </mat-dialog-actions>
</form>
